import { render, staticRenderFns } from "./ItemCreateDialog.vue?vue&type=template&id=a004f7b2"
import script from "./ItemCreateDialog.vue?vue&type=script&lang=js"
export * from "./ItemCreateDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports